module.exports = __webpack_public_path__ + "static/img/printbg1.6695cb3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/report/printbg1.png
// module id = 3Bpc
// module chunks = 2